const formatPhoneNumber = (phoneNumberString = '') => {
  const splitStringByExt = (String(phoneNumberString)).split('Ext:');
  const match = splitStringByExt[0].replace(/\D/g, '').match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]} ${splitStringByExt[1] ? `Ext: ${splitStringByExt[1]}` : ''}`;
  }
  const rawPhoneNumberString = (String(phoneNumberString)).split('');
  return `(${rawPhoneNumberString.splice(0, 3).join('')}) ${rawPhoneNumberString.splice(0, 3).join('')}-${rawPhoneNumberString.splice(0, 4).join('')} Ext:${rawPhoneNumberString.splice(0, rawPhoneNumberString.length).join('')}`;
};

export default formatPhoneNumber;



// WEBPACK FOOTER //
// ./src/helpers/formatPhoneNumber.js